export default __webpack_public_path__ + "static/media/documentLoading.1fffe451.gif";